<template>
  <v-card :disabled="isDisabled">
    <UserBadge :have-permissions="!isDisabled" :read-only="!canWrite"/>
    <v-col cols="12" v-if="!canWrite" no-gutters
      class="blue-grey--text text--lighten-1 pt-0 pb-0">
      <v-icon color="red">mdi-alert-box-outline</v-icon>
      {{ $t('perms.nochange') }}
    </v-col>
    <v-card-title primary class="title grey--text pb-0">
      <v-switch :disabled="!canWrite"
        class="cf-switch" v-model="enabled" :label="$t('settings.fwd.title')">
        <template v-slot:prepend>
          <v-icon :color="enabled ? 'green' : 'grey'">mdi-call-missed</v-icon>
        </template>
        <template v-slot:append>
          <cp-help i18n="callfwd"/>
        </template>
      </v-switch>
    </v-card-title>
    <v-card-text class="pa-4" v-show="enabled">
      <v-row>
        <v-col class="pl-1 cf-number">
          <v-text-field :label="$t('settings.fwd.num')"
            :hint="$t('settings.fwd.hint')"
            :rules="[validator]"
            clearable
            v-model="number"
            @keyup.enter="save"
            prepend-icon="mdi-cellphone-settings">
          </v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-icon color="red" class="mr-3" v-if="isDisabled" small>mdi-lock</v-icon>
      <v-btn text :disabled="!isReadyToSave" data-testid="save-btn" class="save-btn" @click="save">
        {{ $t('settings.fwd.save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import events from 'Store/events'
import * as RMQClient from '@/rmqclient'
import API from '@/api'
import UserBadge from './user_badge'

export default {
  name: 'settings-call-forward',
  data () {
    return {
      validator: this.validateNumber
    }
  },
  components: { UserBadge },
  computed: {
    ...mapGetters({
      fwdData: 'settings/callfwd',
      canRead: 'permissions/fwdRead',
      fwdWrite: 'permissions/fwdWrite',
      fwdWriteFor: 'permissions/fwdWriteFor',
      sipUser: 'sipua/exten',
      activeSubAccount: 'settings/activeSubAccount',
      ownerID: 'settings/ownerID',
      isOwnerCurUser: 'settings/isOwnerCurUser',
      realm: 'settings/realm'
    }),
    enabled: {
      get: function () {
        return this.canRead && this.fwdData.enabled
      },
      set: function (val) {
        this.updateCallFwd({ enabled: val, number: this.number })
      }
    },
    number: {
      get: function () {
        return this.fwdData.number
      },
      set: function (val) {
        this.updateCallFwd({ enabled: true, number: val })
      }
    },
    isDisabled: function () {
      if (!this.activeSubAccount || this.isOwnerCurUser) {
        return false
      }
      return !this.activeSubAccount.features?.includes('forward')
    },
    canWrite: function () {
      if (!this.activeSubAccount || this.isOwnerCurUser) {
        return this.fwdWrite
      }
      return this.fwdWriteFor(this.activeSubAccount?.subscriber_id)
    },
    isReadyToSave: function () {
      if (!this.canWrite) {
        return false
      }
      if (this.validateNumber(this.number) === true) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions({
      updateCallFwd: 'settings/setCallFwd',
      publishCallFwd: 'sipua/publishCallFwd'
    }),
    save: function () {
      if (!this.validateNumber(this.number)) {
        return
      }
      events.mask()
      API.settingsCallFwd(this.ownerID, this.enabled, this.number)
        .then(() => {
          const key = 'settings.notify.fwd' + (this.enabled ? 'Saved' : 'Off')
          this.publishCallFwd(this.enabled)
          events.pubNotify({ text: key, status: 'success' })
          RMQClient.sendCmd({
            route: 'DIRECT',
            action: 'BUDDYPREF',
            pref: 'FORWARD',
            username: this.sipUser,
            realm: this.realm,
            enabled: this.enabled
          })
        }).catch(err => {
          this.dbg(err)
          events.pubError(API.getException(err) || 'API failed to update call forward.')
        }).finally(events.unmask)
    },
    validateNumber: function (value) {
      if (!this.enabled) return true
      if (!value || value.trim().length === 0) {
        return this.$t('settings.fwd.errRequired')
      }
      if (!/^[\d*#]+$/.test(value)) {
        return this.$t('settings.fwd.errInvalid')
      }
      return true
    }
  }
}
</script>

<style scoped>
</style>
